import { CreditCard } from "lucide-react";

export default function TransactionHeader({ currentTransaction, onReset }) {
  const isCompleted = currentTransaction?.status === 'FULFILLED' || currentTransaction?.status === 'CANCELLED';
  const isPending = currentTransaction?.status === 'INITIATED';
  
  const getHeaderText = () => {
    if (isCompleted) return 'Transaction Completed';
    if (isPending) return 'Continue Transaction';
    return 'New Transaction';
  };

  const getSubText = () => {
    if (isCompleted) return 'Transaction has been processed successfully';
    if (isPending) return 'Complete or cancel this pending transaction';
    return 'Process customer transactions and apply discounts';
  };
  
  return (
    <div className="theme-card rounded-lg p-4 md:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
        <div className="flex items-center space-x-3">
          <div className="bg-primary-light p-2 rounded-lg">
            <CreditCard className="h-6 w-6 md:h-8 md:w-8 text-primary" />
          </div>
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-gray-900">
              {getHeaderText()}
            </h1>
            <p className="text-sm md:text-base text-gray-600 mt-1">
              {getSubText()}
            </p>
            {isPending && (currentTransaction?.reference_id || currentTransaction?.uuid) && (
              <p className="text-xs text-blue-600 mt-1 font-mono">
                ID: {(currentTransaction.reference_id || currentTransaction.uuid).substring(0, 8)}...
              </p>
            )}
          </div>
        </div>
        {isCompleted && (
          <button
            onClick={onReset}
            className="theme-button-primary px-4 py-2 text-sm rounded-lg w-full sm:w-auto"
          >
            New Transaction
          </button>
        )}
      </div>
    </div>
  );
}